import {Injectable} from '@angular/core';
import {ToastrService} from 'ngx-toastr';

import {HttpClient} from '@angular/common/http';
import {catchError, map, Observable, throwError} from 'rxjs';
import {AppConfigurationService} from '../../base/appConfiguration.service';

declare const google: any;

@Injectable({
  providedIn: 'root',
})
export class AgendaService {
  constructor(
    private toastr: ToastrService,
    private httpClient: HttpClient,
    private appConfigurationService: AppConfigurationService,
  ) {}
  checarGravacaoAuditoria(data: any): Observable<any> {
    return this.httpClient
      .post<any>(`${this.appConfigurationService.apiBaseUrl}/GoogleWorkspace/recordings/check-recording`, data)
      .pipe(
        map(response => {
          return response;
        }),
        catchError(err => {
          return throwError(() => ({
            message: err.message,
            status: err.status,
          }));
        }),
      );
  }

  buscarEventosPorProposta(idProposta: string): Observable<any> {
    return this.httpClient
      .get<any>(
        `${this.appConfigurationService.apiBaseUrl}/GoogleWorkspace/appointments/events-by-proposal/${idProposta}`,
      )
      .pipe(
        map(response => {
          return response;
        }),
        catchError(err => {
          return throwError(() => ({
            message: err.message,
            status: err.status,
          }));
        }),
      );
  }

  listarEventosAgenda(dateStart: string, dateEnd: string): Observable<any> {
    return this.httpClient
      .get<any>(
        `${this.appConfigurationService.apiBaseUrl}/GoogleWorkspace/calendar/events?dateStart=${dateStart}&dateEnd=${dateEnd}`,
      )
      .pipe(
        map(response => {
          return response;
        }),
        catchError(err => {
          return throwError(() => ({
            message: err.message,
            status: err.status,
          }));
        }),
      );
  }

  cadastrarEventoBloqueio(data: any): Observable<any> {
    return this.httpClient
      .post<any>(`${this.appConfigurationService.apiBaseUrl}/GoogleWorkspace/calendar/block-event`, data)
      .pipe(
        map(response => {
          return response;
        }),
        catchError(err => {
          return throwError(() => ({
            message: err.message,
            status: err.status,
          }));
        }),
      );
  }

  apagarEvento(idEvento: string, proposalId?: string): Observable<any> {
    let url = `${this.appConfigurationService.apiBaseUrl}/GoogleWorkspace/calendar/event/${idEvento}`;

    if (proposalId) {
      url += `?proposalId=${proposalId}`;
    }

    return this.httpClient.delete<any>(url).pipe(
      map(response => {
        return response;
      }),
      catchError(err => {
        return throwError(() => ({
          message: err.message,
          status: err.status,
        }));
      }),
    );
  }

  agendarVideoConferencia(objEvento: any): Observable<any> {
    return this.httpClient
      .post<any>(`${this.appConfigurationService.apiBaseUrl}/GoogleWorkspace/appointments`, objEvento)
      .pipe(
        map(response => {
          return response;
        }),
        catchError(err => {
          return throwError(() => ({
            message: err.message,
            status: err.status,
          }));
        }),
      );
  }

  buscarHorariosDisponeveis(dataInicio: any, dataFim: any): Observable<any> {
    return this.httpClient
      .get(
        `${this.appConfigurationService.apiBaseUrl}/GoogleWorkspace/calendar/vailable-events?dateStart=${dataInicio}&dateEnd=${dataFim}`,
      )
      .pipe(
        map(response => {
          return response;
        }),
        catchError(err => {
          return throwError(() => ({
            message: err.message,
            status: err.status,
          }));
        }),
      );
  }
}
